import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import { Organization } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Pipe({
  name: "department",
  standalone: false
})
export class DepartmentPipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );

  transform(departmentId: string): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      shareReplay(),
      map(org => {
        const orgDepartment = org.departments.find(d => d.departmentId === departmentId);
        return `${orgDepartment?.displayName ?? "[department not found]"}`;
      })
    );
  }
}
